var map = {
	"./Expand.png": "e631",
	"./Hamburger.png": "521d",
	"./Logical Framework (5).png": "35e2",
	"./Share-button.png": "a233",
	"./caution.png": "f06e",
	"./close-icon.png": "c2f4",
	"./close.png": "cd5c",
	"./code.png": "6a6c",
	"./contact.png": "9fa8",
	"./dashboard.png": "461b",
	"./facebook.png": "5307",
	"./faq.png": "afd6",
	"./feature.png": "eb62",
	"./feedback.png": "f1fc",
	"./full.png": "5a0f",
	"./html.png": "b55a",
	"./img/(per 1000 live births) (NHMIS - 2019) (1).png": "fd8f",
	"./img/(per 1000 live births) (NHMIS - 2019).png": "fa06",
	"./img/(per 1000 live births) 2.png": "2d17",
	"./img/(per 1000 live births) NDHS_2018.png": "8d28",
	"./img/(per 1000 live births).png": "73b6",
	"./img/Assets/FAQ_Asset.png": "db27",
	"./img/Framework.png": "3549",
	"./img/Group 81.png": "93ff",
	"./img/Image 3.png": "8483",
	"./img/analytics/Bubble Chart Analysis.png": "e983",
	"./img/analytics/Correlation Analysis.png": "be54",
	"./img/analytics/Descriptive Analysis.png": "5adb",
	"./img/analytics/Indicator Comparison.png": "db7a",
	"./img/analytics/Multi-source Indicator Comparison.png": "6921",
	"./img/analytics/Predictive Analysis.png": "5966",
	"./img/analytics/bkg.png": "edec",
	"./img/browser.png": "2207",
	"./img/health-think/profile.png": "b074",
	"./img/health-think/shutterstock_416638408.png": "7f6c",
	"./img/onboard/onboard1.png": "7ae5",
	"./linkedin.png": "dd32",
	"./logo-full.png": "7560",
	"./logo-old-black.png": "ac4c",
	"./new-dataset.png": "8e7f",
	"./play.png": "df84",
	"./plugin.png": "d8fa",
	"./print.png": "2487",
	"./refresh.png": "684f",
	"./request.png": "ed29",
	"./share.png": "75e1",
	"./state-profile/img/email.png": "587b",
	"./state-profile/img/facebook.png": "cfab",
	"./state-profile/img/link.png": "4faf",
	"./state-profile/img/linkedin.png": "c974",
	"./state-profile/img/twitter.png": "bd22",
	"./submit.png": "6b70",
	"./subscribe.png": "08fe",
	"./twitter.png": "e4d7",
	"./whatapp.png": "17f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";